import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useRecoilState } from 'recoil';
import { addFabricBeforeAtom, canvasToggleRenderAtom, fabricAtom, selectedCustomFabricAtom, selectedFabricAtom, uploadFabricAtom, uploadImageAtom, addFabricToggleAtom, cropperSelectionAtom, selectedPartAtom, addNewCustomFabricAtom, beforeSelectedImageScaletom } from '../../state';
import { v4 as uuidv4 } from 'uuid';

const MyDropzone = () => {
    const [selectedPart, setSelectedPart] = useRecoilState(selectedPartAtom);

    const [fabric, setFabricsAtomState] = useRecoilState(fabricAtom);
    const [selectedFabric, setSelectedFabric] = useRecoilState(selectedFabricAtom);
    const [uploadFabricModel, setUploadFabricModel] = useRecoilState(uploadFabricAtom);
    const [addFabricBefore, setAddFabricBefore] = useRecoilState(addFabricBeforeAtom);
    const [selectedCustomFabric, setSelectedCustomFabricAtom] = useRecoilState(selectedCustomFabricAtom)
    const [canvasToggleRender, setCanvasToggleRender] = useRecoilState(canvasToggleRenderAtom)
    const [addFabricToggle, setAddFabricToggle] =
        useRecoilState(addFabricToggleAtom);
    const [cropperData, setCropperData] = useRecoilState(cropperSelectionAtom)
    const [uploadImage, setUploadImage] = useRecoilState(uploadImageAtom)
    const [addNewCustomFabric, setAddNewCustomFabric] = useRecoilState(addNewCustomFabricAtom)
    const [inputSetValue, setInputSetValue] = useRecoilState(beforeSelectedImageScaletom);
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles?.forEach((file) => {
            const reader = new FileReader()
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = async () => {
                const binaryStr = reader.result
                const fabricName = fabric?.currentPart?.[0]
                setAddFabricBefore({ ...addFabricBefore, [fabricName]: binaryStr })
                if (fabric?.partWiseFabric.Front || fabric?.partWiseFabric.Back) {
                    // Create a copy of the existing partWiseFabric object
                    const partWiseFabricCopy = { ...fabric?.partWiseFabric };
                    // Remove the fabricName key from the partWiseFabricCopy object
                    delete partWiseFabricCopy[fabricName];
                    // Update the state with the modified partWiseFabric object
                    setFabricsAtomState({ ...fabric, partWiseFabric: partWiseFabricCopy });
                }
                setSelectedCustomFabricAtom({ id: '' })
                setSelectedFabric({})
                let customData = {
                    ...selectedCustomFabric,
                    finish: binaryStr,
                    selectedPart: selectedPart?.name,
                    Scale: 1,
                    // aspectRation,
                    name: "Custom",
                    cropperData: binaryStr
                }
                customData = { ...customData, id: uuidv4() }
                if (selectedPart?.name) {
                    setInputSetValue({
                        ...inputSetValue,
                        [selectedPart.name]: customData
                    })
                }

                const partWiseFabric = fabric.currentPart.reduce((acc, part) => {
                    acc[part] = customData
                    return acc
                }, {})
                const newFabric = { ...fabric, partWiseFabric: { ...fabric.partWiseFabric, ...partWiseFabric } };

                setFabricsAtomState({
                    ...newFabric,
                })
                setSelectedCustomFabricAtom(customData)
                setAddNewCustomFabric([...addNewCustomFabric, customData])
                if (selectedPart?.name) {
                    setUploadImage({
                        ...addFabricBefore,
                        [selectedPart.name]: binaryStr
                    })
                }
                setCropperData(binaryStr)
                setAddFabricToggle(true)
                setUploadFabricModel(false)
                setCanvasToggleRender([])
            }
            reader.readAsDataURL(file);
        })
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: { 'image/*': [] } })

    return (
        <div {...getRootProps()}>
            <input id="image" type="file" className="dropzone" {...getInputProps()} />
            <div className="text-center cursor-pointer drop-zone d-flex flex-column justify-content-center">
                <div className="item-choose mx-2 mb-3">
                    <img src="/image-gallery.png" id="image" className="img-fluid m-auto h-16 w-16" alt='camo' />
                </div>
                <div className='color-gray'>
                    Drop your image here or
                    <span className='green-color'> browse</span>
                </div>
            </div>
        </div>
    )
}
export default MyDropzone;